import * as React from "react";
import {Skeleton} from "antd";
import styled from "styled-components";

const SkeletonWrapper = styled.section`
    margin: 0 auto;
    max-width: 1200px;
        
    & > * {
        margin-bottom: 1rem;
    }
`

const CustomSkeleton = () => (
    <SkeletonWrapper>
        <Skeleton.Input active block/>
        <Skeleton.Input active block/>
        <Skeleton.Input active block/>
    </SkeletonWrapper>
)

export default CustomSkeleton;
